import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=785e7856&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=785e7856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e7856",
  null
  
)

export default component.exports